import React from "react";
import type { DashboardWidget } from "../../../types/dashboard/dashboard.types";

// ✅ Tes widgets existants (selon tes fichiers)
import Notification from "../../Dashboard/alerts";
import FleetCo2 from "../../Dashboard/fleetCo2";
import FleetCounter from "../../Dashboard/fleetCounter";
import FleetSate from "../../Dashboard/fleetSate";
import StatsComponent from "../../Dashboard/StatsComponent";

type WidgetConfig = Record<string, any>;

function safeParseConfig(content: string | undefined): WidgetConfig {
    if (!content) return {};
    try {
        const parsed = JSON.parse(content);
        return parsed && typeof parsed === "object" ? parsed : {};
    } catch {
        return {};
    }
}

export default function WidgetRenderer({ widget }: { widget: DashboardWidget }) {
    const config = safeParseConfig(widget.content);

    switch (widget.type) {
        /**
         * ✅ ALERTS / NOTIFICATIONS
         * Ton composant attend: { Notifications } :contentReference[oaicite:5]{index=5}
         * On prendra config.Notifications (array) sinon []
         */
        case "alerts":
            return (
                <Notification
                    id={widget.id}
                    type="notifications"
                    Notifications={config.Notifications ?? []}
                />
            );



        /**
         * ✅ FLEET STATE PIE
         * Ton composant attend: { options } :contentReference[oaicite:6]{index=6}
         */
        case "fleet_state":
            return (
                <FleetSate
                    options={{
                        DrivingValue: Number(config.DrivingValue ?? 0),
                        ParkingValue: Number(config.ParkingValue ?? 0),
                        ParkingEngineRunningValue: Number(config.ParkingEngineRunningValue ?? 0),
                        LastTransmissionValue: Number(config.LastTransmissionValue ?? 0),
                    }}
                />
            );

        /**
         * ✅ FLEET CO2
         * Ton composant déclare props "data" mais ne l'utilise pas :contentReference[oaicite:7]{index=7}
         * On peut quand même passer config.data si tu l’ajoutes plus tard.
         */
        case "fleet_co2":
            return <FleetCo2 data={config.data} /> as any;

        /**
         * ✅ FLEET COUNTER
         * Ton composant attend:
         * numberOfItem, title, icon, color, linkTo :contentReference[oaicite:8]{index=8}
         */
        case "fleet_counter":
            return (
                <FleetCounter
                    numberOfItem={Number(config.numberOfItem ?? 0)}
                    title={String(config.title ?? "Counter")}
                    icon={String(config.icon ?? "car")}
                    color={String(config.color ?? "bg-primary")}
                    linkTo={String(config.linkTo ?? "/vehicles")}
                />
            );

        /**
         * ✅ STATS (Speedometer)
         * Ton composant attend psn :contentReference[oaicite:9]{index=9}
         */
        case "stats":
            return <StatsComponent psn={String(config.psn ?? "")} type={"statsComponent"} id={""} />;

        default:
            return (
                <div style={{ opacity: 0.7 }}>
                    Type widget inconnu: <b>{widget.type}</b>
                    <br />
                    content: {widget.content}
                </div>
            );
    }
}
